export const extractCdns = (cdns) => {
  if (!cdns || !Array.isArray(cdns)) {
    return [];
  }
  return cdns.map((cdn) => cdn.urlOrTag);
};

const saveAIgeneratedCssCdns = async (
  cdns,
  projectId,
  version,
  customComponentId,
  addCustomComponentCssCdn,
  customCssCdns,
) => {
  if (!cdns || !Array.isArray(cdns) || cdns.length === 0) return;
  try {
    const existingUrls = customCssCdns.map((item) => item.urlOrTag);
    for (const cdn of cdns) {
      if (cdn.urlOrTag && !existingUrls.includes(cdn.urlOrTag)) {
        const cdnData = {
          projectId,
          version,
          componentId: customComponentId,
          urlOrTag: cdn.urlOrTag,
        };
        try {
          await addCustomComponentCssCdn(cdnData);
        } catch (error) {
          console.log(error);
        }
      }
    }
  } catch (error) {
    console.error('Error saving filtered CSS CDNs:', error);
  }
};

const saveAIgeneratedJsCdns = async (
  cdns,
  projectId,
  version,
  customComponentId,
  addCustomComponentJsCdn,
  customJsCdns,
) => {
  if (!cdns || !Array.isArray(cdns) || cdns.length === 0) {
    console.log('No JS CDNs to save');
    return;
  }

  try {
    const existingUrls = customJsCdns.map((item) => item.urlOrTag);
    for (const cdn of cdns) {
      if (cdn.urlOrTag && !existingUrls.includes(cdn.urlOrTag)) {
        const cdnData = {
          projectId,
          version,
          componentId: customComponentId,
          urlOrTag: cdn.urlOrTag,
        };

        try {
          const res = await addCustomComponentJsCdn(cdnData);
        } catch (error) {
          console.error('Error saving a JS CDN:', error);
        }
      }
    }
  } catch (error) {
    console.error('Error filtering and saving JS CDNs:', error);
  }
};

const parseAIResponse = async (aiCdns) => {
  if (!Array.isArray(aiCdns)) return [];
  try {
    const parsedList = aiCdns.map((item) => (typeof item === 'string' ? JSON.parse(item) : item));
    return parsedList;
  } catch (error) {
    console.error('Error parsing AI response CDNs:', error);
    return [];
  }
};

export const handleGenerateComponent = async (
  generateCustomComponent,
  args,
  setHtmlContent,
  setCustomCSS,
  setCustomJS,
  customComponentId,
  addCustomComponentCssCdn,
  addCustomComponentJsCdn,
  customCssCdns,
  customJsCdns,
) => {
  try {
    const { projectId, version } = args;
    const generatedContent = await generateCustomComponent(args);

    let aiCssCdns = [];
    let aiJsCdns = [];

    if (generatedContent && generatedContent.data) {
      const content = generatedContent.data.data;

      setHtmlContent(content.htmlContent || '');
      setCustomCSS(content.customCSS || '');
      setCustomJS(content.customJS || '');

      aiCssCdns = Array.isArray(content.customCssCdns) ? content.customCssCdns : [];
      aiJsCdns = Array.isArray(content.customJsCdns) ? content.customJsCdns : [];
    }

    const parsedCssCdnsList = await parseAIResponse(aiCssCdns);
    const parsedJsCdnsList = await parseAIResponse(aiJsCdns);

    await saveAIgeneratedCssCdns(
      parsedCssCdnsList,
      projectId,
      version,
      customComponentId,
      addCustomComponentCssCdn,
      customCssCdns,
    );

    await saveAIgeneratedJsCdns(
      parsedJsCdnsList,
      projectId,
      version,
      customComponentId,
      addCustomComponentJsCdn,
      customJsCdns,
    );
  } catch (error) {
    console.error('Error in generating component', error);
    throw error;
  }
};
